import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Card from './Card'
import * as styles from './index.vanilla.css'

interface FaqData {
  title: string
  content: React.ReactNode
}

const getFaqData: () => FaqData[] = () => [
  {
    title: i18n.t('expenses_v2.cards.blocks.faq_section.collapsables.card_accounts.title'),
    content: (
      <>
        <Text size="300" htmlTag="p">
          {i18n.tView(
            'expenses_v2.cards.blocks.faq_section.collapsables.card_accounts.content.first_paragraph',
            {
              virtual_single_use_debit: (
                <b>
                  {i18n.t(
                    'expenses_v2.cards.blocks.faq_section.collapsables.card_accounts.content.virtual_single_use_debit'
                  )}
                </b>
              ),
            }
          )}
        </Text>
        <Text size="300" htmlTag="p">
          {i18n.tView(
            'expenses_v2.cards.blocks.faq_section.collapsables.card_accounts.content.second_paragraph',
            {
              receive_a_new_account_number: (
                <b>
                  {i18n.t(
                    'expenses_v2.cards.blocks.faq_section.collapsables.card_accounts.content.receive_a_new_account_number'
                  )}
                </b>
              ),
            }
          )}
        </Text>
        <Text size="300" htmlTag="p">
          {i18n.t(
            'expenses_v2.cards.blocks.faq_section.collapsables.card_accounts.content.third_paragraph'
          )}
        </Text>
      </>
    ),
  },
  {
    title: i18n.t('expenses_v2.cards.blocks.faq_section.collapsables.account_extra_cost.title'),
    content: (
      <>
        <Text size="300" htmlTag="p">
          {i18n.tView(
            'expenses_v2.cards.blocks.faq_section.collapsables.account_extra_cost.content.first_paragraph',
            {
              non_eu_fees: (
                <b>
                  {i18n.t(
                    'expenses_v2.cards.blocks.faq_section.collapsables.account_extra_cost.content.non_eu_fees'
                  )}
                </b>
              ),
            }
          )}
        </Text>
        <ul className={styles.cardUl}>
          <li className={styles.cardUlLi}>
            {i18n.t(
              'expenses_v2.cards.blocks.faq_section.collapsables.account_extra_cost.content.second_paragraph'
            )}
          </li>
          <li className={styles.cardUlLi}>
            {i18n.t(
              'expenses_v2.cards.blocks.faq_section.collapsables.account_extra_cost.content.third_paragraph'
            )}
          </li>
        </ul>
      </>
    ),
  },
  {
    title: i18n.t('expenses_v2.cards.blocks.faq_section.collapsables.documentation_needed.title'),
    content: (
      <>
        <Text size="300" htmlTag="p">
          {i18n.t(
            'expenses_v2.cards.blocks.faq_section.collapsables.documentation_needed.content.first_paragraph'
          )}
        </Text>
        <Text size="300" htmlTag="p">
          {i18n.tView(
            'expenses_v2.cards.blocks.faq_section.collapsables.documentation_needed.content.second_paragraph',
            {
              company: (
                <b>
                  {i18n.t(
                    'expenses_v2.cards.blocks.faq_section.collapsables.documentation_needed.content.company'
                  )}
                </b>
              ),
            }
          )}
        </Text>
        <Text size="300" htmlTag="p">
          {i18n.tView(
            'expenses_v2.cards.blocks.faq_section.collapsables.documentation_needed.content.third_paragraph',
            {
              representative: (
                <b>
                  {i18n.t(
                    'expenses_v2.cards.blocks.faq_section.collapsables.documentation_needed.content.representative'
                  )}
                </b>
              ),
            }
          )}
        </Text>

        <Box background="grey000White" padding="s16" borderRadius={{ all: 'abs008' }}>
          <Text size="300" htmlTag="p">
            {i18n.tView(
              'expenses_v2.cards.blocks.faq_section.collapsables.documentation_needed.content.fourth_paragraph',
              {
                valid_address_documents: (
                  <Text size="300" weight="medium" color="grey1000">
                    ☝️
                    {i18n.t(
                      'expenses_v2.cards.blocks.faq_section.collapsables.documentation_needed.content.valid_address_documents'
                    )}
                  </Text>
                ),
              }
            )}
          </Text>
        </Box>
        <Box background="grey000White" padding="s16" borderRadius={{ all: 'abs008' }}>
          <Text size="300" htmlTag="p">
            {i18n.tView(
              'expenses_v2.cards.blocks.faq_section.collapsables.documentation_needed.content.fifth_paragraph',
              {
                valid_id_documents: (
                  <Text size="300" weight="medium" color="grey1000">
                    ☝️
                    {i18n.t(
                      'expenses_v2.cards.blocks.faq_section.collapsables.documentation_needed.content.valid_id_documents'
                    )}
                  </Text>
                ),
              }
            )}
          </Text>
        </Box>
      </>
    ),
  },
  {
    title: i18n.t('expenses_v2.cards.blocks.faq_section.collapsables.manage_expense.title'),
    content: (
      <>
        <Text size="300" htmlTag="p">
          {i18n.tView(
            'expenses_v2.cards.blocks.faq_section.collapsables.manage_expense.content.first_paragraph',
            {
              create_card_recommendation: (
                <b>
                  {i18n.t(
                    'expenses_v2.cards.blocks.faq_section.collapsables.manage_expense.content.create_card_recommendation'
                  )}
                </b>
              ),
            }
          )}
        </Text>
      </>
    ),
  },
  {
    title: i18n.t('expenses_v2.cards.blocks.faq_section.collapsables.persons_eligible.title'),
    content: (
      <>
        <Text size="300" htmlTag="p">
          {i18n.tView(
            'expenses_v2.cards.blocks.faq_section.collapsables.persons_eligible.content.first_paragraph',
            {
              representative_only: (
                <b>
                  {i18n.t(
                    'expenses_v2.cards.blocks.faq_section.collapsables.persons_eligible.content.representative_only'
                  )}
                </b>
              ),

              avoid_different_inividuals: (
                <b>
                  {i18n.t(
                    'expenses_v2.cards.blocks.faq_section.collapsables.persons_eligible.content.avoid_different_inividuals'
                  )}
                </b>
              ),
            }
          )}
        </Text>
      </>
    ),
  },
  {
    title: i18n.t('expenses_v2.cards.blocks.faq_section.collapsables.countries_eligible.title'),
    content: (
      <>
        <Text size="300" htmlTag="p">
          {i18n.tView(
            'expenses_v2.cards.blocks.faq_section.collapsables.countries_eligible.content.first_paragraph',
            {
              euro_zone: (
                <b>
                  {i18n.t(
                    'expenses_v2.cards.blocks.faq_section.collapsables.countries_eligible.content.euro_zone'
                  )}
                </b>
              ),
            }
          )}
        </Text>
        <Text size="300" htmlTag="p">
          {i18n.t(
            'expenses_v2.cards.blocks.faq_section.collapsables.countries_eligible.content.second_paragraph'
          )}
        </Text>
        <ul className={styles.cardUl}>
          <li className={styles.cardUlLi}>
            {i18n.t(
              'expenses_v2.cards.blocks.faq_section.collapsables.countries_eligible.content.third_paragraph'
            )}
          </li>
          <li className={styles.cardUlLi}>
            {i18n.t(
              'expenses_v2.cards.blocks.faq_section.collapsables.countries_eligible.content.fourth_paragraph'
            )}
          </li>
        </ul>
      </>
    ),
  },
  {
    title: i18n.t('expenses_v2.cards.blocks.faq_section.collapsables.time_needed.title'),
    content: (
      <>
        <Text size="300" htmlTag="p">
          {i18n.t(
            'expenses_v2.cards.blocks.faq_section.collapsables.time_needed.content.first_paragraph'
          )}
        </Text>
        <ul className={styles.cardUl}>
          <li className={styles.cardUlLi}>
            {i18n.tView(
              'expenses_v2.cards.blocks.faq_section.collapsables.time_needed.content.second_paragraph',
              {
                prohibited_businesses: (
                  <a href="https://stripe.com/es/legal/restricted-businesses">
                    {i18n.t(
                      'expenses_v2.cards.blocks.faq_section.collapsables.time_needed.content.prohibited_businesses'
                    )}
                  </a>
                ),
              }
            )}
          </li>
          <li className={styles.cardUlLi}>
            {i18n.t(
              'expenses_v2.cards.blocks.faq_section.collapsables.time_needed.content.third_paragraph'
            )}
          </li>
        </ul>
        <Text size="300" htmlTag="p">
          {i18n.tView(
            'expenses_v2.cards.blocks.faq_section.collapsables.time_needed.content.fourth_paragraph',
            {
              assuming_correct: (
                <b>
                  {i18n.t(
                    'expenses_v2.cards.blocks.faq_section.collapsables.time_needed.content.assuming_correct'
                  )}
                </b>
              ),
            }
          )}
        </Text>
      </>
    ),
  },
  {
    title: i18n.t('expenses_v2.cards.blocks.faq_section.collapsables.pay_options.title'),
    content: (
      <>
        <Text size="300" htmlTag="p">
          {i18n.tView(
            'expenses_v2.cards.blocks.faq_section.collapsables.pay_options.content.first_paragraph',
            {
              apple_google_wallets: (
                <b>
                  {i18n.t(
                    'expenses_v2.cards.blocks.faq_section.collapsables.pay_options.content.apple_google_wallets'
                  )}
                </b>
              ),
            }
          )}
        </Text>
      </>
    ),
  },
  {
    title: i18n.t('expenses_v2.cards.blocks.faq_section.collapsables.legal_entity.title'),
    content: (
      <>
        <Text size="300" htmlTag="p">
          {i18n.t(
            'expenses_v2.cards.blocks.faq_section.collapsables.legal_entity.content.first_paragraph'
          )}
        </Text>
      </>
    ),
  },
  {
    title: i18n.t('expenses_v2.cards.blocks.faq_section.collapsables.free_cards.title'),
    content: (
      <>
        <Text size="300" htmlTag="p">
          {i18n.tView(
            'expenses_v2.cards.blocks.faq_section.collapsables.free_cards.content.first_paragraph',
            {
              three_cards: (
                <b>
                  {i18n.t(
                    'expenses_v2.cards.blocks.faq_section.collapsables.free_cards.content.three_cards'
                  )}
                </b>
              ),
            }
          )}
        </Text>
        <Text size="300" htmlTag="p">
          {i18n.tView(
            'expenses_v2.cards.blocks.faq_section.collapsables.free_cards.content.second_paragraph',
            {
              eight_cards: (
                <b>
                  {i18n.t(
                    'expenses_v2.cards.blocks.faq_section.collapsables.free_cards.content.eight_cards'
                  )}
                </b>
              ),
            }
          )}
        </Text>
        <Text size="300" htmlTag="p">
          {i18n.tView(
            'expenses_v2.cards.blocks.faq_section.collapsables.free_cards.content.third_paragraph',
            {
              unlimited_cards: (
                <b>
                  {i18n.t(
                    'expenses_v2.cards.blocks.faq_section.collapsables.free_cards.content.unlimited_cards'
                  )}
                </b>
              ),
            }
          )}
        </Text>
      </>
    ),
  },
]

const CardWrapper = ({ children }: React.PropsWithChildren) => (
  <Box height="fit-content">{children}</Box>
)

const ColumnWrapper = ({ children }: React.PropsWithChildren) => (
  <Box flexDirection="column" justifyContent="center" height="fit-content" gap="s16" width="full">
    {children}
  </Box>
)

interface FAQSectionProps {
  onContactSupportClick: () => void
  onFAQCardClick?: (question: string) => void
}

const FAQSection: React.FC<FAQSectionProps> = ({ onContactSupportClick, onFAQCardClick }) => {
  const faqSectionData = getFaqData()
  const [openDropdownIndexes, setOpenDropdownIndexes] = React.useState<Set<number>>(new Set())

  const firstFAQColumnData = faqSectionData.filter((_, i) => i % 2 === 0)
  const secondFAQColumnData = faqSectionData.filter((_, i) => i % 2 === 1)
  const secondFAQColumnOffset = firstFAQColumnData.length

  const handleDropdownClick = (index: number, question: string): void => {
    const newOpenDropdownIndexs = new Set(openDropdownIndexes)
    if (newOpenDropdownIndexs.has(index)) {
      newOpenDropdownIndexs.delete(index)
      setOpenDropdownIndexes(newOpenDropdownIndexs)
    } else {
      newOpenDropdownIndexs.add(index)
      setOpenDropdownIndexes(newOpenDropdownIndexs)
      if (onFAQCardClick) {
        onFAQCardClick(question)
      }
    }
  }

  return (
    <Box paddingX="s64" paddingY="s32" width="full" flexDirection="column" gap="s64">
      <Box flexDirection="row" justifyContent="spaceAround">
        <Box flexDirection="column" gap="s8" maxWidth="s400" textAlign="center">
          <Text.Header2 htmlTag="h2">
            {i18n.t('expenses_v2.cards.blocks.faq_section.title')}
          </Text.Header2>
          <Text.Normal>{i18n.t('expenses_v2.cards.blocks.faq_section.subtitle')}</Text.Normal>
        </Box>
      </Box>
      <Box flexDirection="row" justifyContent="center" gap="s16">
        <ColumnWrapper>
          {firstFAQColumnData.map(({ content, title }, index) => (
            <CardWrapper key={title}>
              <Card
                open={openDropdownIndexes.has(index)}
                title={title}
                content={content}
                onClick={() => {
                  handleDropdownClick(index, title)
                }}
              />
            </CardWrapper>
          ))}
        </ColumnWrapper>
        <ColumnWrapper>
          {secondFAQColumnData.map(({ content, title }, i) => {
            const index = i + secondFAQColumnOffset
            return (
              <CardWrapper key={title}>
                <Card
                  open={openDropdownIndexes.has(index)}
                  title={title}
                  content={content}
                  onClick={() => {
                    handleDropdownClick(index, title)
                  }}
                />
              </CardWrapper>
            )
          })}
        </ColumnWrapper>
      </Box>

      <Box flexDirection="row" justifyContent="center">
        <Button onClick={onContactSupportClick} type="upgrade">
          {i18n.t('expenses_v2.cards.blocks.faq_section.contact_support')}
        </Button>
      </Box>
    </Box>
  )
}

export default FAQSection
